module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAKklEQVRIx2P8c1GMgTaAcdToUaNHjSbJaAaLyaNGD32jzwmqjRo95I0GANSPHAM4SOkcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/co.png
// module id = 799
// module chunks = 0